export const OPEN_CREATE_PRODUCT_MODAL = 'OPEN_CREATE_PRODUCT_MODAL';
export const openCreateProductModal = modalKey => ({
  type: OPEN_CREATE_PRODUCT_MODAL,
  payload: modalKey
});

export const CLEAR_CREATE_PRODUCT_MODAL = 'CLEAR_CREATE_PRODUCT_MODAL';
export const clearCreateProductModal = () => ({
  type: CLEAR_CREATE_PRODUCT_MODAL,
  payload: null
});

/**
 * Handoff tur menu affiliate (Dashboard) -> lanjutan on-page di '/as-affiliate'.
 *
 * Flag ini sengaja hanya hidup di memori redux: begitu halamannya di-reload, ia hilang dan tur
 * lanjutan tidak jalan. Itu yang dimaui — plan induk TIDAK menyimpan status sudah-dilihat, jadi
 * jangan menambah localStorage/mutation di sini. Yang men-set: tur menu affiliate, tepat sebelum
 * `history.push('/as-affiliate')`. Yang membersihkan: `AsAffiliates/components/affiliate-page-tour`
 * saat turnya selesai/dilewati/ditutup, dan saat halamannya ditinggalkan.
 */
export const SET_AFFILIATE_PAGE_TOUR_PENDING = 'SET_AFFILIATE_PAGE_TOUR_PENDING';
export const setAffiliatePageTourPending = () => ({
  type: SET_AFFILIATE_PAGE_TOUR_PENDING,
  payload: true
});

export const CLEAR_AFFILIATE_PAGE_TOUR_PENDING = 'CLEAR_AFFILIATE_PAGE_TOUR_PENDING';
export const clearAffiliatePageTourPending = () => ({
  type: CLEAR_AFFILIATE_PAGE_TOUR_PENDING,
  payload: false
});
